export default __webpack_public_path__ + "static/media/acq_preview.d5b3dfc2.png";